import * as React from "react";
import { ComponentType, FC } from "react";
import { UseLoadAction, UseLoadAdditionalParams, useLoadData } from "../hooks/useLoadData";
import { ContentLoading } from "./ContentLoading";
import { Loading, LoadingTheme } from "./Loading";

interface WithLoadDataProps {
    loadData: UseLoadAction;
    loadOptions?: UseLoadAdditionalParams;
    withLoadingDelay?: boolean;
    fixedLoading?: boolean;
}

export const WithLoadData =
    <P extends {}>(UnwrappedComponent: ComponentType<P>): FC<WithLoadDataProps & P> =>
    ({ loadData, loadOptions, withLoadingDelay, fixedLoading = true, ...restProps }) => {
        const isLoading = useLoadData(loadData, loadOptions);

        return isLoading ? (
            fixedLoading ? (
                <ContentLoading withDelay={withLoadingDelay} />
            ) : (
                <Loading theme={LoadingTheme.big} withDelay={withLoadingDelay} />
            )
        ) : (
            <UnwrappedComponent {...(restProps as P)} />
        );
    };
